import React, {Component} from 'react';
import {connect} from 'react-redux';
import querystring from 'querystring';
import {deselectItem, selectItem, updateItem} from '../../../actions/comment/guestbookComment';
import classnames from 'classnames';
import ItemCheckbox from "../../common/CommentItemCheckbox";
import {ipMasking} from '../../../utils/formatter';
import {Link} from 'react-router-dom'
import GuestBookCommentListItemButton from "./GuestBookCommentListItemButton";
import {addPrefix} from "../../../utils/UriUtil";
import {TISTORY} from "../../../constants/Service";

// Title Render
function Title(props) {
  const {item} = props;
  const linkToComment = (e, item) => {
    if (item.deleting) e.preventDefault();
  };

  return <strong className="tit_post">
    <a href={addPrefix(`/guestbook#comment${item.id}`)} target="_blank" className="link_cont" onClick={(e) => linkToComment(e, item)}>
      {item.parent !== null && <span className="info_status">[답글]</span>}
      {item.comment}
      {item.secret && <span className="ico_blog ico_security"/>}
    </a>
  </strong>
}

// Author Render
function Author(props) {
  const {item} = props;
  const escapeAtChar = item.author.substring(1, item.author.length);

  if (window.Config.service === TISTORY ) {
    return (
      <Link to={"/guestbook?" + querystring.stringify(Object.assign({}, {
        searchKeyword: escapeAtChar,
        searchType: 'writer'
      }))}>
        <span className="txt_cate">{item.author}</span>
      </Link>
    );
  }else {
    return (
      <span className="txt_cate">{item.author}</span>
    )
  }
}


@connect(state => ({
  useCommentRecognition: state.blog.blogSettings.useCommentRecognition,
}), dispatch => ({
  handleSelectItem: (id) => {
    dispatch(selectItem(id))
  },
  handleDeselectItem: (id) => {
    dispatch(deselectItem(id))
  },
  handleUpdateItem: (item) => {
    dispatch(updateItem(item))
  },
  dispatch
}))
class GuestBookCommentListItem extends Component {

  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect(e) {
    const {item, handleSelectItem, handleDeselectItem} = this.props;
    if (item.selected) {
      handleDeselectItem(item.id)
    } else {
      handleSelectItem(item.id)
    }
  }

  render() {
    const {item, useCommentRecognition} = this.props;
    return (
      <li className={classnames({item_dimmed: item.deleting})}>
        <ItemCheckbox item={item} handleSelect={this.handleSelect}/>
        <div className="post_cont">
          <Author item={item}/>
          <span className="txt_info fst">{ipMasking(item.ip)}</span>
          <span className="txt_info">{item.written}</span>
          <Title item={item}/>
        </div>
        <div className="post_btn">
          <div className="info_btn">
            <GuestBookCommentListItemButton
              item={item}
              useCommentRecognition={useCommentRecognition}
            />
          </div>
        </div>
      </li>
    );
  }
}

export default GuestBookCommentListItem;
